import useTranslation from '../Hooks/useTranslation'
import styles from './QtyPickerRetail.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faMagnifyingGlassChart, faCheck, faTag, faMinus, faPlus, faPen, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'
import { faBox, faCircleQuestion, faStars } from '@fortawesome/pro-solid-svg-icons'
import usePrefStore from '../stores/prefs'
import Button from './Button'
import useHelpers from '../Hooks/useHelpers'
import useRetailRoleForCustomer from '../Hooks/useRetailRoleForCustomer'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Keypad from './Keypad'
import useRetailCollections from '../Hooks/useRetailCollections'
import useTarifs from '../Hooks/useTarifs'
import DynImage from './DynImage'
import useSales from '../Hooks/useSales'
import useRetailQuota from '../Hooks/useRetailQuota'
// import { useLogger } from '../Contexts/Logger';
// import useTest from "../Hooks/useTest"
import useStock from '../Hooks/useStock'
import { getRetailStockDepots } from '../libs/retailStockDepots'

function PickerButton(props) {
   const [addClasses, setAddClasses] = useState('')
   const [stockStatus, setStockStatus] = useState(styles.stock_unknown)

   function onClick(evt) {
      evt.stopPropagation()
      if (props.onClick && !props.disabled) {
         props.onClick(props.value)
      }
   }

   useEffect(() => {
      let newClass = ''
      if (props.selected) {
         newClass = newClass + ' ' + styles.selected
      }
      if (props.tiny) {
         newClass = newClass + ' ' + styles.tiny
      }
      if (props.disabled) {
         newClass = newClass + ' ' + styles.picker_disabled
      }
      setAddClasses(newClass)

      if (props.stock === 'ok') {
         setStockStatus(styles.stock_ok)
      } else if (props.stock === 'nok') {
         setStockStatus(styles.stock_nok)
      } else if (props.stock === 'warn') {
         setStockStatus(styles.stock_warn)
      } else {
         setStockStatus(styles.stock_unknown)
      }
   }, [props])

   return (
      <button className={`${stockStatus} ${styles.pickerbutton} ${addClasses}`} onClick={onClick}>
         {props.children}
      </button>
   )
}

const stockStatuses = {
   inconnu: 1,
   indispo: 2,   // pb réseau / auth → on n'a pas pu déterminer le stock
   dispo: 3,
   empty: 4      // toutes les requêtes ont répondu, mais aucun stock nulle part
}

function QtyPickerRetail(props) {
   const { trans } = useTranslation()
   const { globalClosePopups, debug, curOrder, qtyMaxOrder } = usePrefStore()
   // States
   const [, setStockChecked] = useState<any>(false)
   const [quantitySingle, setQuantitySingle] = useState(1)
   const [model, setModel] = useState<any>({})
   const [, setCurPrice] = useState(null)
   const [curCessPrice, setCurCessPrice] = useState(null)
   // const [availColors, setAvailColors] = useState(null); // Toutes les couleurs disponibles
   // const [availSizes, setAvailSizes] = useState(null); // Toutes les tailles disponibles, toutes couleurs confondues
   // const [availSizesForCurSingleColor, setAvailSizesForCurSingleColor] =
   //    useState(null); // Toutes les tailles disponibles pour la couleur (single) choisie
   // const [allQuantitiesByColorSize, setAllQuantitiesByColorSize] = useState<any>({}); // Mode multi : Quantité par couleur+taille. Format {couleur{taille: qté, ...}, ...}
   const [curQtyInKeyPad, setCurQtyInKeyPad] = useState(null) // Mode multi : Quantité en cours de saisie
   const [prevQtyInKeyPad, setPrevQtyInKeyPad] = useState(null) // Mode multi : Sauvegarde de l'ancienne quantité avant de se mettre en cours de saisie
   // const [selectedColorInMulti, setSelectedColorInMulti] = useState(null); // Couleur choisie en mode multi ou null si pas de sélection active
   // const [selectedSizeInMulti, setSelectedSizeInMulti] = useState(null); // Taille choisie en mode multi ou null si pas de sélection active
   // const [curSingleColor, setCurSingleColor] = useState(null); // Couleur choisie en mode single
   // const [curSingleSize, setCurSingleSize] = useState(null); // Taille choisie en mode single
   const [errorInTarif] = useState(false) // Code si erreur pour récupérer dans le tarif
   const [showDebug, setShowDebug] = useState(false) // Faut-il montrer les infos de debug ?
   const [isKeypadVisible, setIsKeypadVisible] = useState(false) // Faut-il montrer le keypad ?
   const [isKeypadEnabled, setIsKeypadEnabled] = useState(false) // Le keypad est-il actif ? (en cours de saisie de valeur)
   // const [colorItems, setColorItems] = useState(null);
   // const [sizeItems, setSizeItems] = useState(null);
   const [region, setRegion] = useState(null) // Si on affiche pour un client ou une commande pas sélectionné(e)
   const [, setCurrencyPPU] = useState(null) // Si on affiche pour un client ou une commande pas sélectionné(e)
   const [currencyCES, setCurrencyCES] = useState(null) // Si on affiche pour un client ou une commande pas sélectionné(e)
   const [, /*stocks*/ setStocks] = useState(null) // Les infos de stock récupérées du serveur
   const [stockStatus, setStockStatus] = useState<any>() // Les infos de stock récupérées du serveur
   const [stockLabel, setStockLabel] = useState<string | null>(null) // Libellé détaillé des stocks par dépôt
   // Liste des dépôts retail à interroger pour le stock : cf. getRetailStockDepots
   // (src/libs/retailStockDepots.ts) pour la règle par rôle.
   const [argu, setArgu] = useState(null)
   const [is_retail_order, setIsRetailOrder] = useState(false)
   const [is_kot_order, setIsKOTOrder] = useState(false)
   //
   const { formatCESPriceWithNC, formatRetailPrice } = useHelpers()
   const { getRetailModelById, isExcluBoutique } = useRetailCollections()
   const { getColorsForModel, getMinMaxPriceForModel, getMinMaxCessPriceForModel } = useTarifs()
   const { getCustomerById, getOrderById, isRetailOrder, isKOTOrder, isKTMOrder } = useSales()
   const { getRetailQuota } = useRetailQuota()
   const refKeypad = useRef(null)
   // const { log } = useLogger();
   const { findRegionFromCessionTarifNames, findRegionFromPublicTarifNames } = useTarifs()
   const { fetchStock } = useStock()
   const [quotaRemaining, setQuotaRemaining] = useState<number | null>(null)
   const [quotaBudgeted, setQuotaBudgeted] = useState<number | null>(null)

   // console.log("QTY", quantitySingle)
   // console.log('QTY_PICKER', props)

   useEffect(() => {
      /**
       * Structure de AllQuantitiesByColorSize
       * {
       *    WG: {
       *       47: 5,
       *       ...
       *    }
       *    ...
       * }
       */
      // const res = props?.multi?.reduce((prev, val) => {
      props?.multi?.reduce((prev, val) => {
         const color = val.color
         const size = val.size
         const qty = val.qty

         // console.log(`Color: ${color}, Size: ${size}, Qty: ${qty}`)
         if (color && prev[color]) {
            if (size && prev[color][size]) {
               console.error(`QtyPickerRetail - On a déjà une ligne pour ${model}-${color}-${size} !`)
               return { ...prev }
            } else {
               // console.log('ICI1');
               return { ...prev, [color]: { ...prev[color], [size]: qty } }
            }
         } else {
            // console.log('ICI2');
            return { ...prev, [color]: { [size]: qty } }
         }
      }, {})
      // setAllQuantitiesByColorSize(res ?? {})
      // console.log('setAllQuantitiesByColorSize', res ?? {})
      // if (props?.color) {
      //    setCurSingleColor(props.color)
      // }
      // if (props?.size) {
      //    setCurSingleSize(props.size)
      // }
      if (props?.qty) {
         setQuantitySingle(props.qty)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.model, props.qty])

   useEffect(() => {
      getOrderById(curOrder).then((order) => {
         setIsRetailOrder(isRetailOrder(order))
         setIsKOTOrder(isKOTOrder(order) || isKTMOrder(order))
      })
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [curOrder])

   useEffect(() => {
      // console.log('::PROPS', props);
      if (props.customer) {
         const a_customer = getCustomerById(props.customer)
         // console.log('::A_CUST', a_customer);
         // const region_name = findRegionFromTarifNames(a_customer?.tarifs.ppu.tarif, a_customer?.tarifs.ppu.currency)
         let region_name = findRegionFromCessionTarifNames(a_customer?.tarifs.ces.tarif, a_customer?.tarifs.ces.currency)
         if (!region_name) {
            // !!!!! NB : OUI, c'est bien CES qui est pris dans a_customer pour chercher la région. C'est pour les clients qui n'ont pas de tarif cession mais un tarif public remisé
            region_name = findRegionFromPublicTarifNames(a_customer?.tarifs.ces.tarif, a_customer?.tarifs.ces.currency)
         }
         // console.log('::REGION', region_name);
         setCurrencyPPU(a_customer?.tarifs.ppu.currency)
         setCurrencyCES(a_customer?.tarifs.ces.currency)
         // console.log('::CURRENCY_CES', currencyCES);
         // console.log('::CURRENCY_PPU', currencyPPU);

         setRegion(region_name)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.customer])

   // Calcul des dépôts à interroger. Admin et N1 du customer voient tous les dépôts.
   // N2 du customer voit le dépôt du client + le dépôt central SFR. Les rôles Client
   // (RET/ERE/INT) voient juste celui de leur fiche client.
   const roleForCustomer = useRetailRoleForCustomer(props.customer)
   const depots = useMemo<string[]>(() => {
      const a_customer = props.customer ? getCustomerById(props.customer) : null
      return getRetailStockDepots(roleForCustomer, a_customer?.depot_retail ?? null)
   }, [roleForCustomer, props.customer, getCustomerById])

   // console.log('>>>PROPS', props);

   useEffect(() => {
      const allColors = getColorsForModel(props.model)
      console.log('getColorsForModel', props.model, allColors, allColors.colors?.length > 0 ? allColors.colors[0] : null)

      const the_model = getRetailModelById(props.model)
      setModel(the_model)
      if (isExcluBoutique(the_model)) {
         // console.log('+++MODEL3');
         // setArgu(trans('?Exclu boutique'))
         setArgu(<FontAwesomeIcon icon={faStars} />)
      } else {
         // console.log('+++MODEL4');
         setArgu(null)
      }

      // setAvailColors(allColors.colors);
      // if (!props.color) {  // Couleur pas donnée par l'appelant (on vient surement du catalogue)
      //    setCurSingleColor(allColors.colors?.length > 0 ? allColors.colors[0] : null); // Trouver une autre façon que de prendre par défaut le 1er de la liste ?
      // }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.model])

   // useEffect(() => {
   //    const arr = getAllSizesForModel(props.model).sizes
   //    // console.log('getAllSizesForModel(props.model).sizes', arr)
   //    if (arr?.length) {
   //       setAvailSizes(arr);
   //    } else {
   //       setAvailSizes(['']);
   //    }
   // }, [getAllSizesForModel, props]);

   // useEffect(() => {
   //    console.log('**CHG getAllSizesForModel');
   // }, [getAllSizesForModel])

   // useEffect(() => {
   //    console.log('**CHG getAllSizesForModel', getAllSizesForModel);
   // }, [getAllSizesForModel])

   // useEffect(() => {
   //    console.log('**CHG props.model', props.model);
   // }, [props.model])

   // useEffect(() => {
   //    console.log('**CHG props.onHide', props.onHide);
   // }, [props.onHide])

   // useEffect(() => {
   //    console.log('**CHG props.onAdd', props.onAdd);
   // }, [props.onAdd])

   useEffect(() => {
      const min_max = getMinMaxPriceForModel(props.model, region)
      setCurPrice(min_max?.min)
      const min_max_cess = getMinMaxCessPriceForModel(props.model, region)
      // console.log('::getMinMaxCessPriceForModel', props.model, region, min_max_cess);
      setCurCessPrice(min_max_cess?.min)
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.model, region])

   // Chargement du quota Retail (pas quand on est sur un KOT, car on est en train de définir le quota)
   useEffect(() => {
      if (is_kot_order) {
         setQuotaBudgeted(null)
         setQuotaRemaining(null)
         return
      }
      if (props.model && props.customer) {
         // « Quota restant » = restant HORS la commande courante (budget − consommé des AUTRES
         // commandes ; la commande courante est exclue via excludeOrderId=curOrder). On NE soustrait
         // donc PAS la qté déjà présente dans la commande en cours. Cohérent avec OrderDetail et la
         // table de validation. Règle métier : le quota NE BLOQUE PAS, c'est purement informatif.
         getRetailQuota(props.customer, curOrder).then((quota) => {
            if (quota.kotOrder) {
               const detail = quota.skuQuotas.get(props.model)
               if (detail) {
                  setQuotaBudgeted(detail.budgeted)
                  setQuotaRemaining(detail.remaining)
               } else {
                  // SKU pas dans le budget du KOT → hors quota, mais on n'interdit pas
                  setQuotaBudgeted(null)
                  setQuotaRemaining(null)
               }
            } else {
               // Pas de KOT applicable (futur ou inexistant) → pas de limite
               setQuotaBudgeted(null)
               setQuotaRemaining(null)
            }
         })
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.model, props.customer, is_kot_order, curOrder])

   // useEffect(() => {
   //    const allSizes = getSizesForModelColor(props.model, curSingleColor);

   //    if (!allSizes.sizes && allSizes.reason) {
   //       // error("getSizesForModelColor", allSizes.reason)
   //       setErrorInTarif(
   //          `Error ${allSizes.reason.code} - ${allSizes.reason.id} - ${allSizes.reason.text}`
   //       );
   //    } else {
   //       setErrorInTarif(null);
   //    }
   //    // console.log('getSizesForModelColor', props.model, curSingleColor)
   //    setAvailSizesForCurSingleColor(allSizes.sizes);
   //    setCurSingleSize(cur_size => {
   //       if (!allSizes.sizes?.includes(cur_size)) {
   //          return allSizes.sizes?.length > 0 ? allSizes.sizes[0] : null;
   //       } else {
   //          return cur_size
   //       }
   //    })
   //    // console.log('getMinMaxPriceForModel', props.model, getMinMaxPriceForModel(props.model), getMinMaxPriceForModel(props.model)?.min)
   //    const min_max = getMinMaxPriceForModel(props.model, region)
   //    setCurPrice(min_max?.min);

   //    const min_max_cess = getMinMaxCessPriceForModel(props.model, region)
   //    // console.log('::getMinMaxCessPriceForModel', props.model, region, min_max_cess);
   //    setCurCessPrice(min_max_cess?.min);
   // }, [curSingleColor, getMinMaxPriceForModel, getMinMaxCessPriceForModel, getSizesForModelColor, props, region]);

   // console.log('PICK_MODEL', model, props, curPrice)

   function onClickBackground() {
      console.log('onClickBackground')
      if (props.onHide) {
         if (globalClosePopups !== 'button') {
            props.onHide()
         }
      }
   }

   function doNothing(evt) {
      // Empêche les clics dans la box de remonter jusqu'au .background (qui fermerait la popup).
      // Si le keypad est déjà ouvert, un clic ailleurs dans la box le referme (comme sur le picker bjx).
      // ATTENTION : ne pas appeler cancelKeypad() inconditionnellement — sinon le clic d'ouverture
      // sur le span "qté" rouvre puis referme le keypad dans la même frame (state pas encore propagé).
      evt.stopPropagation()
      if (isKeypadVisible) {
         cancelKeypad()
      }
   }

   function hidePopup() {
      if (props.onHide) {
         props.onHide()
      }
   }

   function doCancel() {
      hidePopup()
   }

   function doAddOrUpdate() {
      const func = props.onAdd ?? props.onUpdate
      // La différence entre Add et Update ne sert juste qu'à distinguer comment on doit afficher le texte dans le bouton : "Ajouter" ou "Modifier", sinon les 2 fonctions ont le même type de code dans le propriétaire du <QtyPickerRetail... Cependant il n'en faut qu'un seul et Add est prioritaire

      console.log(func)

      if (func) {
         // func(props.model, false, [{ color: curSingleColor, size: curSingleSize, qty: quantitySingle }])
         func(props.model, false, [{ qty: quantitySingle }])
      }
      hidePopup()
   }

   // Saisie de la quantité au clavier : chiffres 0-9 = construire la qty,
   // Backspace = supprimer le dernier chiffre, Entrée = valider, Échap = annuler.
   // La première frappe de chiffre remplace la qty par défaut (1).
   const [hasTypedQty, setHasTypedQty] = useState(false)
   useEffect(() => {
      function onKeyDown(e: KeyboardEvent) {
         if (isKeypadEnabled) return   // le Keypad interne gère déjà les frappes
         // Calcul du plafond. Le quota n'est plus bloquant : c'est purement informatif.
         const maxQty = qtyMaxOrder
         if (e.key >= '0' && e.key <= '9') {
            e.preventDefault()
            const digit = Number(e.key)
            const newValue = hasTypedQty ? quantitySingle * 10 + digit : digit
            if (newValue <= maxQty) {
               setQuantitySingle(newValue)
               setHasTypedQty(true)
            }
         } else if (e.key === 'Backspace') {
            e.preventDefault()
            const newValue = Math.floor(quantitySingle / 10)
            setQuantitySingle(newValue)
            setHasTypedQty(true)
         } else if (e.key === 'Enter') {
            e.preventDefault()
            if (quantitySingle >= 1) doAddOrUpdate()
         } else if (e.key === 'Escape') {
            e.preventDefault()
            doCancel()
         }
      }
      window.addEventListener('keydown', onKeyDown)
      return () => window.removeEventListener('keydown', onKeyDown)
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [hasTypedQty, quantitySingle, qtyMaxOrder, quotaRemaining, is_kot_order, props.qty, isKeypadEnabled])

   async function checkAvail() {
      const result = await fetchStock(props.model, depots)
      setStocks(result.stocks)
      setStockLabel(result.label)
      // 3 états distincts :
      //   - error  → "Indisponible" (rouge) : pb réseau / auth, on n'a rien pu lire
      //   - !available et !error → "Pas de stock" (rouge) : tous les dépôts ont répondu 0
      //   - available → "Disponible" (vert) avec le détail par dépôt
      const newStatus = result.error
         ? stockStatuses.indispo
         : result.available
            ? stockStatuses.dispo
            : stockStatuses.empty
      setStockStatus(newStatus)
      setStockChecked(true)
   }

   function addQuantity(val) {
      let newVal = quantitySingle + val
      // Le quota n'est plus bloquant — pas de plafonnement par le quota.
      const maxQty = qtyMaxOrder

      // Borner entre 1 et maxQty (minimum 1 toujours)
      newVal = Math.max(1, Math.min(newVal, Math.max(1, maxQty)))
      setQuantitySingle(newVal)
      focusKeypad()
   }

   function validateMultiQuantity(val) {
      // console.log("VALID", val)
      closeKeypad()
   }

   // function getQtyForColorSize(color, size) {
   //    if (allQuantitiesByColorSize && allQuantitiesByColorSize[color]) {
   //       return allQuantitiesByColorSize[color][size === "" ? null : size] ?? 0;
   //       // return allQuantitiesByColorSize[color][size] ?? 0;
   //    } else {
   //       return 0;
   //    }
   // }

   // function setQtyForColorSize(color, size, value) {
   //    setAllQuantitiesByColorSize({
   //       ...allQuantitiesByColorSize,
   //       [color]: { ...allQuantitiesByColorSize[color], [size === "" ? null : size]: value }
   //    });
   // }

   function cancelKeypad() {
      if (isKeypadVisible) {
         // if (selectedColorInMulti === null) {
         // On est en mode mono
         console.log('ICI2')
         setQuantitySingle(prevQtyInKeyPad) // On remet la valeur précédente
         // } else {
         //    setQtyForColorSize(
         //       selectedColorInMulti,
         //       selectedSizeInMulti,
         //       prevQtyInKeyPad
         //    ); // On remet la valeur précédente
         // }
      }
      setCurQtyInKeyPad(null)
      closeKeypad()
   }

   function closeKeypad() {
      // setSelectedColorInMulti(null);
      // setSelectedSizeInMulti(null);
      setIsKeypadVisible(false)
      setIsKeypadEnabled(false)
   }

   // force : permet de ne pas tester la visibilité du keypad quand on est sûr et parce que le useState<any>() ne sera pas forcément le reflet de son état réel au moment de l'appel de focusKeypad !
   const focusKeypad = useCallback(
      (force = false) => {
         if (force || (isKeypadVisible && isKeypadEnabled)) {
            refKeypad.current.focus()
         }
      },
      [isKeypadEnabled, isKeypadVisible]
   )

   // function activateKeypadInMultiMode(color, size) {
   //    setPrevQtyInKeyPad(getQtyForColorSize(color, size));
   //    setSelectedColorInMulti(color);
   //    setSelectedSizeInMulti(size);
   //    setCurQtyInKeyPad(0);
   //    // console.log('RefKeyPad', refKeypad)
   //    setIsKeypadVisible(true);
   //    setIsKeypadEnabled(true);
   //    focusKeypad(true);
   // }

   function activateKeypadInMonoMode() {
      setPrevQtyInKeyPad(quantitySingle)
      // setSelectedColorInMulti(null); // Par sécurité
      // setSelectedSizeInMulti(null); // Par sécurité
      setCurQtyInKeyPad(0)
      // refKeypad.current.focus()
      setIsKeypadVisible(true)
      setIsKeypadEnabled(true)
      focusKeypad(true)
   }

   // function doSelectCellForMulti(color, size) {
   //    if (selectedColorInMulti === color && selectedSizeInMulti === size) {
   //       cancelKeypad();
   //    } else {
   //       activateKeypadInMultiMode(color, size);
   //    }
   // }

   // const selectColor = useCallback((color) => {
   //    setCurSingleColor(color);
   //    focusKeypad();
   // },
   //    [focusKeypad]
   // );

   // const selectSize = useCallback((size) => {
   //    setCurSingleSize(size);
   //    focusKeypad();
   // },
   //    [focusKeypad]
   // );

   function toggleShowDebug() {
      setShowDebug(!showDebug)
   }

   function onKeypadChange(val) {
      console.log('--->')
      setCurQtyInKeyPad(val)
      // if (selectedColorInMulti !== null) {
      //    setQtyForColorSize(selectedColorInMulti, selectedSizeInMulti, val);
      // } else {
      console.log('ICI3')
      setQuantitySingle(val)
      // }
   }

   // Affiche le keypad en mode mono (l'utilisateur a cliqué sur le champ quantité)
   function toggleShowKeypad() {
      if (!isKeypadVisible) {
         activateKeypadInMonoMode()
      } else {
         closeKeypad()
      }
   }

   // useEffect(() => {
   //    let keys

   //    if (stocks) {
   //       keys = Object.keys(stocks)
   //       console.log('Keys', keys);
   //    }

   //    setColorItems(
   //       availColors?.map((item) => {
   //          let stock_level = null, stock_value
   //          const cur_key = `${props.model}-${item}`
   //          // const stock_value = stocks ? stocks[cur_key] : null

   //          console.log('KEYS', keys);
   //          if (keys) {
   //             stock_value = keys.reduce((prev, a_key) => {
   //                console.log(a_key, cur_key);
   //                if (a_key.includes(cur_key)) {
   //                   return prev + stocks[a_key]
   //                } else {
   //                   return prev
   //                }
   //             }, 0)
   //             console.log('QTE', stock_value);
   //             if (stock_value > glob_const.stock_levels.WARN) {
   //                stock_level = 'ok'
   //             } else if (stock_value > glob_const.stock_levels.NOK) {
   //                stock_level = 'warn'
   //             } else if (stock_value !== null) {
   //                stock_level = 'nok'
   //             }
   //          }

   //          if (item === curSingleColor) {
   //             return (
   //                <PickerButton key={`color_${item}`} value={item} selected stock={stock_level}>
   //                   {item}
   //                </PickerButton>
   //             );
   //          } else {
   //             return (
   //                <PickerButton key={`color_${item}`} value={item} stock={stock_level} onClick={selectColor}>
   //                   {item}
   //                </PickerButton>
   //             );
   //          }
   //       })
   //    );
   // }, [availColors, curSingleColor, props, selectColor, stocks]);

   // useEffect(() => {
   //    // console.log('Stocks=', stocks);
   //    setSizeItems(
   //       availSizesForCurSingleColor?.map((item) => {
   //          let stock_level = null

   //          if (stocks) {
   //             let stock_value
   //             const cur_key = `${props.model}-${curSingleColor}-${item}`

   //             stock_value = stocks[cur_key]
   //             if (stock_value > glob_const.stock_levels.WARN) {
   //                stock_level = 'ok'
   //             } else if (stock_value > glob_const.stock_levels.NOK) {
   //                stock_level = 'warn'
   //             } else if (stock_value !== null) {
   //                stock_level = 'nok'
   //             }
   //          }

   //          if (item === curSingleSize) {
   //             return (
   //                <PickerButton key={`size_${item}`} value={item} selected stock={stock_level}>
   //                   {item}
   //                </PickerButton>
   //             );
   //          } else {
   //             return (
   //                <PickerButton key={`size_${item}`} value={item} stock={stock_level} onClick={selectSize}>
   //                   {item}
   //                </PickerButton>
   //             );
   //          }
   //       })
   //    );
   // }, [availSizesForCurSingleColor, curSingleSize, curSingleColor, selectSize, stocks, props]);

   // useEffect(() => {
   //    console.log("***qtyByColorSize***")
   // }, [qtyByColorSize])

   // console.log('AVAIL COLORS', availColors, curSingleColor)
   // console.log('AVAIL SIZES', availSizesForCurSingleColor, curSingleSize)
   // console.log('qtyByColorSize', qtyByColorSize)

   useEffect(() => {
      if (isKeypadVisible && isKeypadEnabled) {
         focusKeypad(true)
      }
   }, [isKeypadVisible, isKeypadEnabled, focusKeypad])

   // console.log(props.qty, curOrder);

   // TODO : Virer le background de ce QtyPickerRetail qui fait doublon avec le DarkLayer du Catalog
   return (
      <div className={styles.background} onClick={onClickBackground}>
         <div className={styles.qty_picker_retail} onClick={doNothing}>
            <div className={styles.top}>
               <FontAwesomeIcon icon={faBox} />
               <span>{trans('?Sélecteur de quantité')}</span>
               {errorInTarif && (
                  <div>
                     <FontAwesomeIcon icon={faTriangleExclamation} onClick={toggleShowDebug} />
                     {debug && showDebug && <span>{errorInTarif}</span>}
                  </div>
               )}
               <button onClick={hidePopup}>
                  <FontAwesomeIcon icon={faXmark} />
               </button>
            </div>
            <div className={styles.header}>
               <span className={styles.modelid}>{model.id}</span>
               <span className={styles.label}>
                  <span className={styles.label_text}>{model.label}</span>
                  {argu && <span className={styles.argu}>{argu}</span>}
               </span>
               <div className={styles.info}>
                  <span className={styles.picto}>
                     <FontAwesomeIcon icon={faTag} />
                  </span>
                  <span className={styles.text}>{formatRetailPrice(model, formatCESPriceWithNC(curCessPrice, currencyCES), props.customer ? getCustomerById(props.customer) : null)}</span>
               </div>
               <div className={styles.status_row}>
                  {quotaRemaining !== null &&
                     (() => {
                        const quotaClass = quotaRemaining <= 0 ? styles.quota_exhausted : styles.quota_ok
                        return (
                           <div className={`${styles.quota_info} ${quotaClass}`}>
                              <span>
                                 {trans('?Quota actuel')} : {quotaRemaining} / {quotaBudgeted ?? 0}
                              </span>
                           </div>
                        )
                     })()}
                  {!stockStatus && (
                     <Button small secondary red lefticon={<FontAwesomeIcon icon={faMagnifyingGlassChart} />} onClick={checkAvail}>
                        {trans('?Vérifier disponibilité')}
                     </Button>
                  )}
                  {stockStatus === stockStatuses.dispo && (
                     <Button small green lefticon={<FontAwesomeIcon icon={faCheck} />}>
                        {stockLabel ?? trans('?Disponible')}
                     </Button>
                  )}
                  {stockStatus === stockStatuses.empty && (
                     <Button small red lefticon={<FontAwesomeIcon icon={faXmark} />}>
                        {trans('?Pas de stock')}
                     </Button>
                  )}
                  {stockStatus === stockStatuses.indispo && (
                     <Button small red lefticon={<FontAwesomeIcon icon={faXmark} />}>
                        {trans('?Indisponible')}
                     </Button>
                  )}
                  {stockStatus === stockStatuses.inconnu && (
                     <Button small secondary red lefticon={<FontAwesomeIcon icon={faCircleQuestion} />}>
                        {trans('?Non communiqué')}
                     </Button>
                  )}
               </div>
            </div>
            <div className={styles.detail}>
               <div className={styles.leftside}>
                  <div className={styles.flipcard}>
                     <div className={styles.flipcard_inner}>
                        <div className={`${styles.flipcard_front} ${!isKeypadVisible ? styles.selected : ''}`}>
                           <DynImage className={styles.imgmodel} src={[`catalogue/ecrins/${model.id}.jpg`, model.bymessika ? model.bymessika[0] : null]} alt={`Model ${model.id}`} />
                           {/* <img src={`catalogue/modeles/${model.id}@2x.png`} alt={`Model ${model.id}`} /> */}
                        </div>
                        <div className={`${styles.flipcard_back} ${isKeypadVisible ? styles.selected : ''}`}>
                           <Keypad ref={refKeypad} onValidate={validateMultiQuantity} visible={false} disabled={!isKeypadEnabled} value={curQtyInKeyPad} min={0} max={qtyMaxOrder} onChange={onKeypadChange} onCancel={cancelKeypad}></Keypad>
                           <div className={styles.keypad_hint}>{trans('?keypad_hint_physical_keyboard')}</div>
                        </div>
                     </div>
                  </div>

                  <div className={styles.quantityblock}>
                     {(() => {
                        // Le quota n'est plus bloquant — on borne uniquement par qtyMaxOrder.
                        const maxQty = qtyMaxOrder
                        const minusDisabled = quantitySingle <= 1
                        const plusDisabled = quantitySingle >= maxQty
                        return (<>
                           <PickerButton tiny selected disabled={minusDisabled} onClick={() => addQuantity(-1)}>
                              <FontAwesomeIcon icon={faMinus} />
                           </PickerButton>
                           <span onClick={toggleShowKeypad} className={`${isKeypadEnabled ? styles.selected : ''}`}>
                              {quantitySingle}
                           </span>
                           <PickerButton tiny selected disabled={plusDisabled} onClick={() => addQuantity(1)}>
                              <FontAwesomeIcon icon={faPlus} />
                           </PickerButton>
                        </>)
                     })()}
                  </div>

                  <div className={styles.footer}>
                     <Button secondary onClick={doCancel}>
                        {trans('?Annuler')}
                     </Button>
                     {curOrder === null && !props.qty && <Button disabled>{trans('?Aucune commande sélectionnée')}</Button>}
                     {(curOrder !== null || props.qty) && !is_retail_order && !is_kot_order && <Button disabled>{trans('?Commande incompatible')}</Button>}
                     {(curOrder !== null || props.qty) && (is_retail_order || is_kot_order) && (
                        <Button
                           lefticon={<FontAwesomeIcon icon={props.onAdd ? faPlus : faPen} />}
                           onClick={doAddOrUpdate}
                        >
                           {trans(props.onAdd ? (is_kot_order ? '?Ajouter aux quotas' : '?Ajouter à la commande') : (is_kot_order ? '?Modifier les quotas' : '?Modifier la commande'))}
                        </Button>
                     )}
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default QtyPickerRetail
